import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "proposal-participant__item" }
const _hoisted_2 = { class: "proposal-participant__avatar" }
const _hoisted_3 = { class: "proposal-participant__name" }
const _hoisted_4 = { class: "proposal-participant__action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcAvatar = _resolveComponent("NcAvatar")!
  const _component_OptionalIcon = _resolveComponent("OptionalIcon")!
  const _component_RequiredIcon = _resolveComponent("RequiredIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_DestroyIcon = _resolveComponent("DestroyIcon")!
  const _component_NcActions = _resolveComponent("NcActions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NcAvatar, {
        user: $options.participantName,
        displayName: $options.participantName,
        disableTooltip: true,
        isNoUser: true
      }, null, 8, ["user", "displayName"])
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString($options.participantName), 1),
    _createElementVNode("div", _hoisted_4, [
      (!$options.participantAttendance)
        ? (_openBlock(), _createBlock(_component_OptionalIcon, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_NcActions, null, {
        default: _withCtx(() => [
          _createVNode(_component_NcActionButton, {
            closeAfterClick: true,
            onClick: $options.onParticipantAttendance
          }, {
            icon: _withCtx(() => [
              (!$options.participantAttendance)
                ? (_openBlock(), _createBlock(_component_RequiredIcon, { key: 0 }))
                : (_openBlock(), _createBlock(_component_OptionalIcon, { key: 1 }))
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(!$options.participantAttendance ? $options.t('calendar', 'Attendance required') : $options.t('calendar', 'Attendance optional')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_NcActionButton, {
            closeAfterClick: true,
            onClick: $options.onParticipantRemove
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_DestroyIcon)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString($options.t('calendar', 'Remove participant')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ])
  ]))
}